import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=2d7a1355"
import script from "./Calendar.vue?vue&type=script&lang=ts"
export * from "./Calendar.vue?vue&type=script&lang=ts"
import style0 from "./Calendar.vue?vue&type=style&index=0&id=2d7a1355&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d7a1355')) {
      api.createRecord('2d7a1355', component.options)
    } else {
      api.reload('2d7a1355', component.options)
    }
    module.hot.accept("./Calendar.vue?vue&type=template&id=2d7a1355", function () {
      api.rerender('2d7a1355', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/project/Calendar.vue"
export default component.exports